import { render } from "./goods.vue?vue&type=template&id=0bec490e&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"

import "./goods.vue?vue&type=style&index=0&id=0bec490e&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\Agent\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bec490e"]])

export default __exports__